import {ChangeDetectorRef, Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[brtOverlayDirective]'
})
export class OverlayDirectiveDirective {

  constructor(public viewContainerRef: ViewContainerRef, public changeDetectorRef: ChangeDetectorRef) { }

}
